import { createAsyncThunk } from "@reduxjs/toolkit";
import { homepageImagesService } from "service/homepageImagesService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getAllHomepageImages = createAsyncThunk(
  "homepageImages/getAllHomepageImages",
  async (pageOptions = {}) => {
    try {
      const response = await homepageImagesService.getAllHomepageImages(
        pageOptions
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllHomepageImagesWithoutPagination = createAsyncThunk(
  "homepageImages/getAllHomepageImagesWithoutPagination",
  async () => {
    try {
      const response =
        await homepageImagesService.getAllHomepageImagesWithoutPagination();
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getHomepageImageById = createAsyncThunk(
  "homepageImages/getHomepageImageById",
  async (id) => {
    try {
      const response = await homepageImagesService.getHomepageImageById(id);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const createHomepageImage = createAsyncThunk(
  "homepageImages/createHomepageImage",
  async (imageData, { rejectWithValue }) => {
    try {
      const response = await homepageImagesService.createHomepageImage(
        imageData
      );
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const updateHomepageImage = createAsyncThunk(
  "homepageImages/updateHomepageImage",
  async ({ id, imageData }, { rejectWithValue }) => {
    try {
      const response = await homepageImagesService.updateHomepageImage(
        id,
        imageData
      );
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const deleteHomepageImage = createAsyncThunk(
  "homepageImages/deleteHomepageImage",
  async (id, { rejectWithValue }) => {
    try {
      await homepageImagesService.deleteHomepageImage(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      return id;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const reorderHomepageImages = createAsyncThunk(
  "homepageImages/reorderHomepageImages",
  async (homepageImageIds, { rejectWithValue }) => {
    try {
      const response = await homepageImagesService.reorderHomepageImages(
        homepageImageIds
      );
      Notify(NOTIFY.type.success, NOTIFY.message.reorder);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
